import type { DateTime } from "luxon";
import { sortDateTime } from "./sortDateTime";

/** Sorting function for Luxon DateTime objects that may be null. */
export function sortDateTimeOrNull(
  aDateTime: DateTime | null,
  bDateTime: DateTime | null,
  nullsFirst: boolean = true
) {
  if (aDateTime === null && bDateTime === null) {
    return 0;
  }

  if (aDateTime === null) {
    return nullsFirst ? -1 : 1;
  }

  if (bDateTime === null) {
    return nullsFirst ? 1 : -1;
  }

  return sortDateTime(aDateTime, bDateTime);
}
